// import { useEffect } from "react";
// import "./styles.css";

// function App() {

//   useEffect(() => {
//     const reveals = document.querySelectorAll(".reveal");

//     const observer = new IntersectionObserver((entries) => {
//       entries.forEach((e) => {
//         if (e.isIntersecting) {
//           e.target.classList.add("visible");
//           observer.unobserve(e.target);
//         }
//       });
//     }, { threshold: 0.1 });

//     reveals.forEach((r) => observer.observe(r));

//     const anchors = document.querySelectorAll('a[href^="#"]');
//     anchors.forEach((a) => {
//       a.addEventListener("click", (e) => {
//         const target = document.querySelector(a.getAttribute("href"));
//         if (target) {
//           e.preventDefault();
//           target.scrollIntoView({ behavior: "smooth" });
//         }
//       });
//     });
//   }, []);

//   // const handleSubmit = (e) => {
//   //   e.preventDefault();

//   //   const name = e.target.name.value.trim();
//   //   const email = e.target.email.value.trim();
//   //   const company = e.target.company.value.trim();
//   //   const inquiry = e.target.inquiry.value;

//   //   if (!name || !email || !company || !inquiry) {
//   //     alert("Please fill in all required fields.");
//   //     return;
//   //   }

//   //   const toast = document.getElementById("toast");
//   //   toast.classList.add("show");
//   //   setTimeout(() => toast.classList.remove("show"), 4000);

//   //   e.target.reset();
//   // };

//   const handleSubmit = (e) => {
//     const form = e.target;
  
//     const name = form.name.value.trim();
//     const email = form.email.value.trim();
//     const company = form.company.value.trim();
//     const inquiry = form.inquiry.value;
  
//     if (!name || !email || !company || !inquiry) {
//       e.preventDefault(); // ❗ only block if invalid
//       alert("Please fill in all required fields.");
//       return;
//     }
  
//     // ✅ allow submit (no preventDefault here)
  
//     const toast = document.getElementById("toast");
//     toast.classList.add("show");
  
//     setTimeout(() => {
//       toast.classList.remove("show");
//     }, 4000);
//   };

//   return (
//     <>
//       {/* NAV */}
//       <nav>
//         <div className="logo">
//           <div className="logo-name">ALANKAAR POWER</div>
//           <div className="logo-sub">Corporation Pvt. Ltd.</div>
//         </div>
//         <ul className="nav-links">
//           <li><a href="#what-we-do">What We Do</a></li>
//           <li><a href="#process">Process</a></li>
//           <li><a href="#market">Market</a></li>
//           <li><a href="#contact">Contact</a></li>
//         </ul>
//         <a href="#contact" className="nav-cta">Get In Touch</a>
//       </nav>

//       {/* HERO */}
//       <section className="hero">
//         <div className="hero-grid-bg"></div>
//         <div className="hero-glow"></div>
//         <div className="hero-inner">
//           <div className="hero-tag">🌏 Built for India's EV Revolution</div>
//           {/* <h1 className="display">
//             Powering India's<br />
//             <span>Circular Battery</span><br />
//             Future
//           </h1> */}
//           {/* <h1 className="display electric-text">
//   {"Powering India's Circular Battery Future".split("").map((char, i) => (
//     <span key={i} className="char">
//       {char === " " ? "\u00A0" : char}
//     </span>
//   ))}
// </h1> */}
// <h1 className="display electric-text">
//   {"Powering India's Circular Battery Future".split(" ").map((word, wi) => (
//     <span key={wi} className="word">
//       {word.split("").map((char, ci) => (
//         <span key={ci} className="char">
//           {char}
//         </span>
//       ))}
//       <span className="space"> </span>
//     </span>
//   ))}
// </h1>
//           <p className="hero-sub">
//             We recycle lithium-ion batteries and recover critical minerals to support the EV revolution — safely, sustainably, and at scale.
//           </p>
//           <div className="hero-btns">
//             <a href="#contact" className="btn-primary">Partenr With Us </a>
//             {/* <a href="#contact" className="btn-outline">Partner With Us</a> */}
//           </div>
//         </div>
//       </section>

//       {/* STATS BAR */}
//       <div className="stats-bar reveal">
//         <div className="stat">
//           <div className="stat-num">5+</div>
//           <div className="stat-label">Tonnes Per Day Capacity</div>
//         </div>
//         <div className="stat">
//           <div className="stat-num">90%</div>
//           <div className="stat-label">Critical Minerals India Imports</div>
//         </div>
//         <div className="stat">
//           <div className="stat-num">50+</div>
//           <div className="stat-label">TPD Future Scale Target</div>
//         </div>
//         <div className="stat">
//           <div className="stat-num">100%</div>
//           <div className="stat-label">EPR & ESG Compliant</div>
//         </div>
//       </div>

//       {/* WHAT WE DO */}
//       <section id="what-we-do">
//         <div className="section-inner">
//           <div className="section-tag">What We Do</div>
//           <h2 className="section-title display">
//             Turning Dead Batteries<br />Into Living Resources
//           </h2>
//           <p className="section-body">
//             No jargon. Here's exactly how we close the loop on lithium battery waste.
//           </p>

//           <div className="what-grid reveal">
//             <div className="what-card">
//               <div className="what-icon">🔋</div>
//               <h3>We Collect Used Batteries</h3>
//               <p>We partner with EV manufacturers, battery producers, and aggregators to collect end-of-life lithium-ion batteries from across India through our growing logistics network.</p>
//             </div>

//             <div className="what-card">
//               <div className="what-icon">⚙️</div>
//               <h3>We Safely Process Them</h3>
//               <p>Batteries are safely discharged, dismantled, and shredded in our controlled facility.</p>
//             </div>

//             <div className="what-card">
//               <div className="what-icon">⚗️</div>
//               <h3>We Extract Valuable Materials</h3>
//               <p>We produce high-grade Black Mass containing lithium, cobalt, nickel, and manganese.</p>
//             </div>

//             <div className="what-card">
//               <div className="what-icon">♻️</div>
//               <h3>Materials Re-Enter the Supply Chain</h3>
//               <p>Recovered minerals are refined and supplied back to battery manufacturers.</p>
//             </div>
//           </div>
//         </div>
//       </section>


//       {/* PROBLEM SECTION */}
//       <section>
//   <div className="section-inner">

//     <div className="section-tag">Why This Matters</div>

//     <h2 className="section-title display">
//       India Has a Battery<br />
//       Waste Crisis Coming
//     </h2>

//     <p className="section-body">
//       The EV boom is real — and so is the mountain of battery waste it will create. Here's what's at stake.
//     </p>

//     <div className="problem-grid reveal">

//       <div className="problem-card">
//         <div className="problem-num">10X</div>
//         <h3>EV Battery Waste Growth</h3>
//         <p>
//           India's EV market is on a steep growth trajectory. As millions of vehicles hit the road, end-of-life battery volumes will grow exponentially over the next decade.
//         </p>
//       </div>

//       <div className="problem-card">
//         <div className="problem-num">90%+</div>
//         <h3>Critical Minerals Imported</h3>
//         <p>
//           India imports over 90% of the lithium, cobalt, and nickel it needs for batteries. Without domestic recycling, this dependency deepens every year.
//         </p>
//       </div>

//       <div className="problem-card">
//         <div className="problem-num">☠️</div>
//         <h3>Improper Disposal = Real Risk</h3>
//         <p>
//           Unprocessed lithium batteries are fire hazards and toxic to soil and water. Informal disposal is rampant — and the regulatory clock is ticking with EPR mandates in force.
//         </p>
//       </div>

//     </div>

//   </div>
// </section>




//       {/* PROCESS SECTION */}
//       <section id="process" style={{ background: "var(--panel)" }}>
//   <div className="section-inner">

//     <div className="section-tag">Our Process</div>

//     <h2 className="section-title display">
//       End-to-End. Transparent.<br />
//       Fully Traceable.
//     </h2>

//     <p className="section-body">
//       From collection to recovery, every step is controlled, compliant, and optimised for maximum material yield.
//     </p>

//     <div className="process-flow reveal">

//       <div className="process-step">
//         <div className="step-num">01</div>
//         <div className="step-icon">🚚</div>
//         <h3>Collection</h3>
//         <p>Batteries collected from OEMs, dealers, and aggregators across India.</p>
//         <div className="step-arrow">→</div>
//       </div>

//       <div className="process-step">
//         <div className="step-num">02</div>
//         <div className="step-icon">⚡</div>
//         <h3>Discharge & Dismantling</h3>
//         <p>Safe discharge to zero volts. Packs dismantled into modules and cells.</p>
//         <div className="step-arrow">→</div>
//       </div>

//       <div className="process-step">
//         <div className="step-num">03</div>
//         <div className="step-icon">🔧</div>
//         <h3>Shredding</h3>
//         <p>Cells shredded in a controlled environment to separate components.</p>
//         <div className="step-arrow">→</div>
//       </div>

//       <div className="process-step">
//         <div className="step-num">04</div>
//         <div className="step-icon">🖤</div>
//         <h3>Black Mass</h3>
//         <p>
//           High-value Black Mass — the mineral-rich powder — is separated and packaged.
//         </p>
//         <div className="step-arrow">→</div>
//       </div>

//       <div className="process-step">
//         <div className="step-num">05</div>
//         <div className="step-icon">💎</div>
//         <h3>Metal Recovery</h3>
//         <p>
//           Li, Co, Ni, Mn extracted and refined for re-entry into the battery supply chain.
//         </p>
//         <div className="step-arrow">→</div>
//       </div>

//     </div>

//   </div>
// </section>






//       {/* USP SECTION */}\
//       <section>
//   <div className="section-inner">
    
//     <div className="section-tag">Why Choose Us</div>

//     <h2 className="section-title display">
//       Built for Scale.<br />
//       Designed for Trust.
//     </h2>

//     <p className="section-body">
//       We're not just a recycler. We're India's battery circular economy infrastructure, built from the ground up.
//     </p>

//     <div className="usp-grid reveal">

//       <div className="usp-item">
//         <div className="usp-icon-wrap">🔄</div>
//         <div>
//           <h3>End-to-End Recycling</h3>
//           <p>
//             From doorstep collection to mineral recovery, we manage the entire lifecycle — no handoffs, no blind spots, full chain-of-custody documentation.
//           </p>
//         </div>
//       </div>

//       <div className="usp-item">
//         <div className="usp-icon-wrap">📈</div>
//         <div>
//           <h3>Scalable Operations</h3>
//           <p>
//             Starting at 5 TPD with a clear roadmap to 50+ TPD. Our modular facility design allows rapid capacity expansion as India's battery waste grows.
//           </p>
//         </div>
//       </div>

//       <div className="usp-item">
//         <div className="usp-icon-wrap">🏆</div>
//         <div>
//           <h3>High-Quality Black Mass Output</h3>
//           <p>
//             Consistently high-grade mineral yield thanks to our optimised process, creating more value for downstream battery manufacturers and refiners.
//           </p>
//         </div>
//       </div>

//       <div className="usp-item">
//         <div className="usp-icon-wrap">✅</div>
//         <div>
//           <h3>Fully EPR & ESG Compliant</h3>
//           <p>
//             Fully aligned with India's Extended Producer Responsibility rules and global ESG standards — helping your business meet its compliance and sustainability obligations.
//           </p>
//         </div>
//       </div>

//     </div>

//   </div>
// </section>



// {/* market sectiopn */}
//       <section id="market" className="market-section">
//   <div className="section-inner">
//     <div className="market-inner">

//       <div className="market-text reveal">
//         <div className="section-tag">Market Opportunity</div>

//         <h2 className="section-title display">
//           The Opportunity<br />Is Enormous
//         </h2>

//         <p className="section-body">
//           India's EV transition is creating a massive, urgent, and underserved battery recycling gap. We're positioned at the centre of it.
//         </p>

//         <div className="market-highlight">
//           Government EPR regulations now make battery recycling mandatory for producers — every OEM in India needs a certified recycling partner. <strong>That partner is us.</strong>
//         </div>
//       </div>

//       <div className="reveal">
//         <div className="market-bars">

//           <div>
//             <div className="mbar-label">
//               <span>EV Penetration Growth</span>
//               <span>+42% CAGR</span>
//             </div>
//             <div className="mbar-track">
//               <div className="mbar-fill" style={{ width: "84%" }}></div>
//             </div>
//           </div>

//           <div>
//             <div className="mbar-label">
//               <span>Battery Recycling Market Size</span>
//               <span>$5B+ by 2030</span>
//             </div>
//             <div className="mbar-track">
//               <div className="mbar-fill" style={{ width: "72%" }}></div>
//             </div>
//           </div>

//           <div>
//             <div className="mbar-label">
//               <span>Critical Mineral Import Dependency</span>
//               <span>90%+</span>
//             </div>
//             <div className="mbar-track">
//               <div
//                 className="mbar-fill"
//                 style={{
//                   width: "90%",
//                   background: "linear-gradient(90deg, var(--amber), #e07b00)"
//                 }}
//               ></div>
//             </div>
//           </div>

//           <div>
//             <div className="mbar-label">
//               <span>EPR Compliance Mandate</span>
//               <span>Active Now</span>
//             </div>
//             <div className="mbar-track">
//               <div className="mbar-fill" style={{ width: "100%" }}></div>
//             </div>
//           </div>

//         </div>
//       </div>

//     </div>
//   </div>
// </section>


      
//       {/* WHO WE WORK WITH */}
// <section>
//   <div className="section-inner">
//     <div className="section-tag">Partners & Clients</div>
//     <h2 className="section-title display">Who We Work With</h2>
//     <p className="section-body">
//       We serve the full spectrum of stakeholders in India's battery and EV ecosystem.
//     </p>

//     <div className="clients-grid reveal">
//       <div className="client-card">
//         <div className="client-icon">🚗</div>
//         <h3>EV Manufacturers</h3>
//         <p>Two-wheelers, three-wheelers, and four-wheelers needing EPR-compliant battery disposal.</p>
//       </div>

//       <div className="client-card">
//         <div className="client-icon">🏭</div>
//         <h3>Battery Producers</h3>
//         <p>Cell manufacturers and pack assemblers with production scrap and end-of-life returns.</p>
//       </div>

//       <div className="client-card">
//         <div className="client-icon">💻</div>
//         <h3>Electronics Companies</h3>
//         <p>Consumer electronics brands with lithium batteries across laptops, phones, and IoT devices.</p>
//       </div>

//       <div className="client-card">
//         <div className="client-icon">📦</div>
//         <h3>Scrap Aggregators</h3>
//         <p>Traders and collection agencies seeking a certified, compliant downstream processing partner.</p>
//       </div>

//       <div className="client-card">
//         <div className="client-icon">🏗️</div>
//         <h3>Energy Storage Operators</h3>
//         <p>BESS and grid-scale storage projects requiring decommissioning and recycling support.</p>
//       </div>

//       <div className="client-card">
//         <div className="client-icon">📊</div>
//         <h3>Investors & VCs</h3>
//         <p>Institutions seeking exposure to India's critical minerals and circular economy opportunity.</p>
//       </div>

//       <div className="client-card">
//         <div className="client-icon">🤝</div>
//         <h3>Technology Partners</h3>
//         <p>Research institutions and technology firms collaborating on advanced hydrometallurgical processes.</p>
//       </div>

//       <div className="client-card">
//         <div className="client-icon">🏛️</div>
//         <h3>Government & PSUs</h3>
//         <p>Public sector units and policy bodies building India's critical mineral self-sufficiency.</p>
//       </div>
//     </div>
//   </div>
// </section>

//       {/* CONTACT
//       <section id="contact" className="contact-section">
//   <div className="section-inner">
//     <div className="contact-wrap">

//       <div className="contact-info reveal">
//         <div className="section-tag">Contact Us</div>
//         <h2>
//           Let's Build the<br />
//           <span>Circular Economy</span><br />
//           Together
//         </h2>

//         <p>
//           Whether you're an OEM needing a recycling partner, a business with battery waste, or an investor looking at India's critical minerals space — we want to hear from you.
//         </p>

//         <div className="contact-details">
//           <div className="contact-detail">
//             <div className="cd-icon">📍</div>
//             <div className="cd-text">
//               <strong>Location</strong>
//               Jaipur, Rajasthan, India
//             </div>
//           </div>

//           <div className="contact-detail">
//             <div className="cd-icon">✉️</div>
//             <div className="cd-text">
//               <strong>Email</strong>
//               info@alankaarpower.in
//             </div>
//           </div>

//           <div className="contact-detail">
//             <div className="cd-icon">📞</div>
//             <div className="cd-text">
//               <strong>Phone</strong>
//               +91 98XXX XXXXX
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="form-box reveal">
//       <form
//          action="https://api.web3forms.com/submit"
//          method="POST"
//          onSubmit={handleSubmit}
//       >
          
//           <div className="form-row">
//             <div className="form-group">
//               <label htmlFor="name">Full Name *</label>
//               <input
//                 type="text"
//                 id="name"
//                 name="name"
//                 placeholder="Ravi Kumar"
//                 required
//               />
//             </div>

//             <div className="form-group">
//               <label htmlFor="company">Company / Organisation *</label>
//               <input
//                 type="text"
//                 id="company"
//                 name="company"
//                 placeholder="Tata Motors"
//                 required
//               />
//             </div>
//           </div>

//           <div className="form-row">
//             <div className="form-group">
//               <label htmlFor="email">Email Address *</label>
//               <input
//                 type="email"
//                 id="email"
//                 name="email"
//                 placeholder="ravi@company.com"
//                 required
//               />
//             </div>

//             <div className="form-group">
//               <label htmlFor="phone">Phone Number</label>
//               <input
//                 type="tel"
//                 id="phone"
//                 name="phone"
//                 placeholder="+91 98765 43210"
//               />
//             </div>
//           </div>

//           <div className="form-group">
//             <label htmlFor="inquiry">Enquiry Type *</label>
//             <select id="inquiry" name="inquiry" required defaultValue="">
//               <option value="" disabled>
//                 Select your interest
//               </option>
//               <option value="recycling">Recycling Service</option>
//               <option value="partnership">Partnership / Collaboration</option>
//               <option value="investment">Investment Opportunity</option>
//               <option value="epr">EPR Compliance Support</option>
//               <option value="other">Other</option>
//             </select>
//           </div>

//           <div className="form-group">
//             <label htmlFor="message">Message</label>
//             <textarea
//               id="message"
//               name="message"
//               placeholder="Tell us about your battery volumes, requirements, or what you'd like to explore..."
//             ></textarea>
//           </div>

//           <button type="submit" className="form-submit">
//             Send Enquiry →
//           </button>

//           <p className="form-note">
//             We respond within 24 hours. Your information is kept strictly confidential.
//           </p>
//         </form>
//       </div>

//     </div>
//   </div>
// </section> */}
// {/* CONTACT */}

// <section id="contact" className="contact-section">
//   <div className="section-inner">
//     <div className="contact-wrap">

// ```
//   {/* LEFT SIDE */}
//   <div className="contact-info reveal">
//     <div className="section-tag">Contact Us</div>
//     <h2>
//       Let's Build the<br />
//       <span>Circular Economy</span><br />
//       Together
//     </h2>

//     <p>
//       Whether you're an OEM, recycler, or investor — we’d love to work with you.
//     </p>

//     <div className="contact-details">
//       <div className="contact-detail">
//         <div className="cd-icon">📍</div>
//         <div className="cd-text">
//           <strong>Location</strong>
//           Jaipur, Rajasthan, India
//         </div>
//       </div>

//       <div className="contact-detail">
//         <div className="cd-icon">✉️</div>
//         <div className="cd-text">
//           <strong>Email</strong>
//           alankaarpower@gmail.com
//         </div>
//       </div>

//       <div className="contact-detail">
//         <div className="cd-icon">📞</div>
//         <div className="cd-text">
//           <strong>Phone</strong>
//           +91 9799495123
//         </div>
//       </div>
//     </div>
//   </div>

//   {/* RIGHT SIDE FORM */}
//   <div className="form-box reveal">
//     <form
//       action="https://api.web3forms.com/submit"
//       method="POST"
//       onSubmit={handleSubmit}
//     >

//       <input type="hidden" name="access_key" value="a4972955-93fb-436e-ac21-4fb4f27485fb" />
//       <input type="hidden" name="subject" value="New Enquiry - Alankaar Power" />
//       <input type="hidden" name="from_name" value="Alankaar Website" />

//       <div className="form-row">
//         <div className="form-group">
//           <label>Full Name *</label>
//           <input type="text" name="name" required />
//         </div>

//         <div className="form-group">
//           <label>Company *</label>
//           <input type="text" name="company" required />
//         </div>
//       </div>

//       <div className="form-row">
//         <div className="form-group">
//           <label>Email *</label>
//           <input type="email" name="email" required />
//         </div>

//         <div className="form-group">
//           <label>Phone</label>
//           <input type="tel" name="phone" />
//         </div>
//       </div>

//       <div className="form-group">
//         <label>Enquiry Type *</label>
//         <select name="inquiry" required defaultValue="">
//           <option value="" disabled>Select your interest</option>
//           <option value="black_mass">Buy Black Mass</option>
//           {/* <option value="battery_recycling">Battery Recycling</option> */}
//           <option value="oem_partnership">Buy From Us(Cu, Al, Fe, Plastic)</option>
//           <option value="bulk_disposal">Sell Battery Scrap (We Buy)</option>
//           <option value="epr_compliance">EPR Partnership</option>
          
//           <option value="investment">Investment</option>
//           <option value="technology">Technology</option>
//           <option value="general">General</option>
//         </select>
//       </div>

//       <div className="form-group">
//         <label>Message</label>
//         <textarea name="message"></textarea>
//       </div>

//       <button type="submit" className="form-submit">
//         Send Enquiry →
//       </button>

//       <p className="form-note">
//         We respond within 24 hours.
//       </p>

//     </form>
//   </div>

// </div>
// ```

//   </div>
// </section>


//       {/* FOOTER */}
      
//   <footer>
//     <div className="footer-brand">
//       <div className="logo">
//         <div className="logo-name">ALANKAAR POWER</div>
//         <div className="logo-sub">Corporation Private Limited</div>
//       </div>

//       <p style={{ marginTop: "1rem" }}>
//         Closing the loop on lithium battery waste. Building India's critical mineral independence from the ground up.
//       </p>
//     </div>

//     <div className="footer-col">
//       <h4>Company</h4>
//       <ul>
//         <li><a href="#what-we-do">What We Do</a></li>
//         <li><a href="#process">Our Process</a></li>
//         <li><a href="#market">Market</a></li>
//         <li><a href="#contact">Contact</a></li>
//       </ul>
//     </div>

//     <div className="footer-col">
//       <h4>Get In Touch</h4>
//       <ul>
//         <li>Jaipur, Rajasthan</li>
//         <li>alnkaarpower@gmail.com</li>
//         <li>+91 9799495123</li>
//       </ul>
//     </div>
//   </footer>

//   <div className="footer-bottom">
//     <span>© 2025 Alankaar Power Corporation Pvt. Ltd. All rights reserved.</span>
//     <span>CIN: U40100RJ2024PTC000000</span>
//   </div>

//   {/* TOAST */}
//   <div className="toast" id="toast">
//     ✓ Enquiry sent! We'll be in touch within 24 hours.
//   </div>
// </>
//   );
// }

// export default App;



import { useEffect } from "react";
import { Routes, Route, Link, useNavigate } from "react-router-dom";
import "./styles.css";

import WhatWeDoPage from "./pages/Whatwedopage";
import WhyItMattersPage from "./pages/Whyitmatterspage";
import ProcessPage from "./pages/Processpage";
import WhyUsPage from "./pages/Whyuspage";
import MarketPage from "./pages/Marketpage";
import WhoWeWorkWithPage from "./pages/Whoweworkwithpage";

import {
  BatteryIcon, GearIcon, AtomIcon, CycleIcon,
  TruckIcon, BoltIcon, WrenchIcon, CrystalIcon,
  CycleIcon as ChainIcon,
  ScaleIcon, ShieldIcon, TrophyIcon,
  CarIcon, FactoryIcon, LaptopIcon, BoxIcon,
  TowerIcon, ChartIcon, HandshakeIcon, PillarIcon,
  WasteIcon, ImportIcon, HazardIcon,
  LocationIcon, MailIcon, PhoneIcon
} from "./Icons";

// ─── SHARED NAV ──────────────────────────────────────────────────────────────
function Navbar() {
  return (
    <nav>
      <Link to="/" className="logo" style={{ textDecoration: "none" }}>
        <div className="logo-name">ALANKAAR POWER</div>
        <div className="logo-sub">Corporation Pvt. Ltd.</div>
      </Link>
      <ul className="nav-links">
        <li><Link to="/what-we-do">What We Do</Link></li>
        <li><Link to="/process">Process</Link></li>
        <li><Link to="/market">Market</Link></li>
        <li><a href="/#contact">Contact</a></li>
      </ul>
      <a href="/#contact" className="nav-cta">Get In Touch</a>
    </nav>
  );
}

// ─── MAIN PAGE ────────────────────────────────────────────────────────────────
function MainPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const reveals = document.querySelectorAll(".reveal");
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add("visible");
          observer.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    reveals.forEach((r) => observer.observe(r));

    const anchors = document.querySelectorAll('a[href^="#"]');
    anchors.forEach((a) => {
      a.addEventListener("click", (e) => {
        const target = document.querySelector(a.getAttribute("href"));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: "smooth" });
        }
      });
    });
  }, []);

  const handleSubmit = (e) => {
    const form = e.target;
    const name = form.name.value.trim();
    const email = form.email.value.trim();
    const company = form.company.value.trim();
    const inquiry = form.inquiry.value;
    if (!name || !email || !company || !inquiry) {
      e.preventDefault();
      alert("Please fill in all required fields.");
      return;
    }
    const toast = document.getElementById("toast");
    toast.classList.add("show");
    setTimeout(() => toast.classList.remove("show"), 4000);
  };

  return (
    <>
      {/* HERO */}
      <section className="hero">
        <div className="hero-grid-bg"></div>
        <div className="hero-glow"></div>
        <div className="hero-inner">
          <div className="hero-tag">🌏 Built for India's EV Revolution</div>
          <h1 className="display electric-text">
            {"Powering India's Circular Battery Future".split(" ").map((word, wi) => (
              <span key={wi} className="word">
                {word.split("").map((char, ci) => (
                  <span key={ci} className="char">{char}</span>
                ))}
                <span className="space"> </span>
              </span>
            ))}
          </h1>
          <p className="hero-sub">
            We recycle lithium-ion batteries and recover critical minerals to support the EV revolution — safely, sustainably, and at scale.
          </p>
          <div className="hero-btns">
            <a href="#contact" className="btn-primary">Partner With Us</a>
          </div>
        </div>
      </section>

      {/* STATS BAR */}
      <div className="stats-bar reveal">
        <div className="stat">
          <div className="stat-num">5+</div>
          <div className="stat-label">Tonnes Per Day Capacity</div>
        </div>
        <div className="stat">
          <div className="stat-num">90%</div>
          <div className="stat-label">Critical Minerals India Imports</div>
        </div>
        <div className="stat">
          <div className="stat-num">50+</div>
          <div className="stat-label">TPD Future Scale Target</div>
        </div>
        <div className="stat">
          <div className="stat-num">100%</div>
          <div className="stat-label">EPR &amp; ESG Compliant</div>
        </div>
      </div>

      {/* WHAT WE DO */}
      <section id="what-we-do">
        <div className="section-inner">
          <div className="section-tag">What We Do</div>
          <h2 className="section-title display">
            Turning Dead Batteries<br />Into Living Resources
          </h2>
          <p className="section-body">
            No jargon. Here's exactly how we close the loop on lithium battery waste.
          </p>

          <div className="what-grid reveal">
            <div className="what-card">
              <div className="what-icon"><BatteryIcon /></div>
              <h3>We Collect Used Batteries</h3>
              <p>We partner with EV manufacturers, battery producers, and aggregators to collect end-of-life lithium-ion batteries from across India through our growing logistics network.</p>
            </div>
            <div className="what-card">
              <div className="what-icon"><GearIcon /></div>
              <h3>We Safely Process Them</h3>
              <p>Batteries are safely discharged, dismantled, and shredded in our controlled facility.</p>
            </div>
            <div className="what-card">
              <div className="what-icon"><AtomIcon /></div>
              <h3>We Extract Valuable Materials</h3>
              <p>We produce high-grade Black Mass containing lithium, cobalt, nickel, and manganese.</p>
            </div>
            <div className="what-card">
              <div className="what-icon"><CycleIcon /></div>
              <h3>Materials Re-Enter the Supply Chain</h3>
              <p>Recovered minerals are refined and supplied back to battery manufacturers.</p>
            </div>
          </div>

          <div className="section-cta reveal">
            <button className="btn-outline" onClick={() => navigate("/what-we-do")}>
              Explore What We Do →
            </button>
          </div>
        </div>
      </section>

      {/* WHY THIS MATTERS */}
      <section id="why-it-matters">
        <div className="section-inner">
          <div className="section-tag">Why This Matters</div>
          <h2 className="section-title display">
            India Has a Battery<br />Waste Crisis Coming
          </h2>
          <p className="section-body">
            The EV boom is real — and so is the mountain of battery waste it will create. Here's what's at stake.
          </p>

          <div className="problem-grid reveal">
            <div className="problem-card">
              <div className="problem-num">10X</div>
              <div className="problem-card-icon"><WasteIcon /></div>
              <h3>EV Battery Waste Growth</h3>
              <p>India's EV market is on a steep growth trajectory. As millions of vehicles hit the road, end-of-life battery volumes will grow exponentially over the next decade.</p>
            </div>
            <div className="problem-card">
              <div className="problem-num">90%+</div>
              <div className="problem-card-icon"><ImportIcon /></div>
              <h3>Critical Minerals Imported</h3>
              <p>India imports over 90% of the lithium, cobalt, and nickel it needs for batteries. Without domestic recycling, this dependency deepens every year.</p>
            </div>
            <div className="problem-card">
              <div className="problem-num">⚠</div>
              <div className="problem-card-icon"><HazardIcon /></div>
              <h3>Improper Disposal = Real Risk</h3>
              <p>Unprocessed lithium batteries are fire hazards and toxic to soil and water. Informal disposal is rampant — and the regulatory clock is ticking with EPR mandates in force.</p>
            </div>
          </div>

          <div className="section-cta reveal">
            <button className="btn-outline" onClick={() => navigate("/why-it-matters")}>
              See the Full Picture →
            </button>
          </div>
        </div>
      </section>

      {/* PROCESS */}
      <section id="process" style={{ background: "var(--panel)" }}>
        <div className="section-inner">
          <div className="section-tag">Our Process</div>
          <h2 className="section-title display">
            End-to-End. Transparent.<br />Fully Traceable.
          </h2>
          <p className="section-body">
            From collection to recovery, every step is controlled, compliant, and optimised for maximum material yield.
          </p>

          <div className="process-flow reveal">
            <div className="process-step">
              <div className="step-num">01</div>
              <div className="step-icon"><TruckIcon /></div>
              <h3>Collection</h3>
              <p>Batteries collected from OEMs, dealers, and aggregators across India.</p>
              <div className="step-arrow">→</div>
            </div>
            <div className="process-step">
              <div className="step-num">02</div>
              <div className="step-icon"><BoltIcon /></div>
              <h3>Discharge &amp; Dismantling</h3>
              <p>Safe discharge to zero volts. Packs dismantled into modules and cells.</p>
              <div className="step-arrow">→</div>
            </div>
            <div className="process-step">
              <div className="step-num">03</div>
              <div className="step-icon"><WrenchIcon /></div>
              <h3>Shredding</h3>
              <p>Cells shredded in a controlled environment to separate components.</p>
              <div className="step-arrow">→</div>
            </div>
            <div className="process-step">
              <div className="step-num">04</div>
              <div className="step-icon"><GearIcon /></div>
              <h3>Black Mass</h3>
              <p>High-value Black Mass — the mineral-rich powder — is separated and packaged.</p>
              <div className="step-arrow">→</div>
            </div>
            <div className="process-step">
              <div className="step-num">05</div>
              <div className="step-icon"><CrystalIcon /></div>
              <h3>Metal Recovery</h3>
              <p>Li, Co, Ni, Mn extracted and refined for re-entry into the battery supply chain.</p>
              <div className="step-arrow">→</div>
            </div>
          </div>

          <div className="section-cta reveal">
            <button className="btn-outline" onClick={() => navigate("/process")}>
              Deep Dive Into Our Process →
            </button>
          </div>
        </div>
      </section>

      {/* WHY CHOOSE US */}
      <section id="why-us">
        <div className="section-inner">
          <div className="section-tag">Why Choose Us</div>
          <h2 className="section-title display">
            Built for Scale.<br />Designed for Trust.
          </h2>
          <p className="section-body">
            We're not just a recycler. We're India's battery circular economy infrastructure, built from the ground up.
          </p>

          <div className="usp-grid reveal">
            <div className="usp-item">
              <div className="usp-icon-wrap"><CycleIcon size={22} /></div>
              <div>
                <h3>End-to-End Recycling</h3>
                <p>From doorstep collection to mineral recovery, we manage the entire lifecycle — no handoffs, no blind spots, full chain-of-custody documentation.</p>
              </div>
            </div>
            <div className="usp-item">
              <div className="usp-icon-wrap"><ScaleIcon size={22} /></div>
              <div>
                <h3>Scalable Operations</h3>
                <p>Starting at 5 TPD with a clear roadmap to 50+ TPD. Our modular facility design allows rapid capacity expansion as India's battery waste grows.</p>
              </div>
            </div>
            <div className="usp-item">
              <div className="usp-icon-wrap"><TrophyIcon size={22} /></div>
              <div>
                <h3>High-Quality Black Mass Output</h3>
                <p>Consistently high-grade mineral yield thanks to our optimised process, creating more value for downstream battery manufacturers and refiners.</p>
              </div>
            </div>
            <div className="usp-item">
              <div className="usp-icon-wrap"><ShieldIcon size={22} /></div>
              <div>
                <h3>Fully EPR &amp; ESG Compliant</h3>
                <p>Fully aligned with India's Extended Producer Responsibility rules and global ESG standards — helping your business meet its compliance and sustainability obligations.</p>
              </div>
            </div>
          </div>

          <div className="section-cta reveal">
            <button className="btn-outline" onClick={() => navigate("/why-us")}>
              Why Alankaar →
            </button>
          </div>
        </div>
      </section>

      {/* MARKET */}
      <section id="market" className="market-section">
        <div className="section-inner">
          <div className="market-inner">
            <div className="market-text reveal">
              <div className="section-tag">Market Opportunity</div>
              <h2 className="section-title display">
                The Opportunity<br />Is Enormous
              </h2>
              <p className="section-body">
                India's EV transition is creating a massive, urgent, and underserved battery recycling gap. We're positioned at the centre of it.
              </p>
              <div className="market-highlight">
                Government EPR regulations now make battery recycling mandatory for producers — every OEM in India needs a certified recycling partner. <strong>That partner is us.</strong>
              </div>
              {/* <div className="section-cta" style={{ marginTop: "2rem" }}>
                <button className="btn-outline" onClick={() => navigate("/market")}>
                  Explore the Market →
                </button>
              </div> */}
            </div>

            <div className="reveal">
              <div className="market-bars">
                <div>
                  <div className="mbar-label">
                    <span>EV Penetration Growth</span>
                    <span>+42% CAGR</span>
                  </div>
                  <div className="mbar-track">
                    <div className="mbar-fill" style={{ width: "84%" }}></div>
                  </div>
                </div>
                <div>
                  <div className="mbar-label">
                    <span>Battery Recycling Market Size</span>
                    <span>$5B+ by 2030</span>
                  </div>
                  <div className="mbar-track">
                    <div className="mbar-fill" style={{ width: "72%" }}></div>
                  </div>
                </div>
                <div>
                  <div className="mbar-label">
                    <span>Critical Mineral Import Dependency</span>
                    <span>90%+</span>
                  </div>
                  <div className="mbar-track">
                    <div className="mbar-fill" style={{ width: "90%", background: "linear-gradient(90deg, var(--amber), #e07b00)" }}></div>
                  </div>
                </div>
                <div>
                  <div className="mbar-label">
                    <span>EPR Compliance Mandate</span>
                    <span>Active Now</span>
                  </div>
                  <div className="mbar-track">
                    <div className="mbar-fill" style={{ width: "100%" }}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WHO WE WORK WITH */}
      <section id="who-we-work-with">
        <div className="section-inner">
          <div className="section-tag">Partners &amp; Clients</div>
          <h2 className="section-title display">Who We Work With</h2>
          <p className="section-body">
            We serve the full spectrum of stakeholders in India's battery and EV ecosystem.
          </p>

          <div className="clients-grid reveal">
            <div className="client-card">
              <div className="client-icon"><CarIcon size={32} /></div>
              <h3>EV Manufacturers</h3>
              <p>Two-wheelers, three-wheelers, and four-wheelers needing EPR-compliant battery disposal.</p>
            </div>
            <div className="client-card">
              <div className="client-icon"><FactoryIcon size={32} /></div>
              <h3>Battery Producers</h3>
              <p>Cell manufacturers and pack assemblers with production scrap and end-of-life returns.</p>
            </div>
            <div className="client-card">
              <div className="client-icon"><LaptopIcon size={32} /></div>
              <h3>Electronics Companies</h3>
              <p>Consumer electronics brands with lithium batteries across laptops, phones, and IoT devices.</p>
            </div>
            <div className="client-card">
              <div className="client-icon"><BoxIcon size={32} /></div>
              <h3>Scrap Aggregators</h3>
              <p>Traders and collection agencies seeking a certified, compliant downstream processing partner.</p>
            </div>
            <div className="client-card">
              <div className="client-icon"><TowerIcon size={32} /></div>
              <h3>Energy Storage Operators</h3>
              <p>BESS and grid-scale storage projects requiring decommissioning and recycling support.</p>
            </div>
            <div className="client-card">
              <div className="client-icon"><ChartIcon size={32} /></div>
              <h3>Investors &amp; VCs</h3>
              <p>Institutions seeking exposure to India's critical minerals and circular economy opportunity.</p>
            </div>
            <div className="client-card">
              <div className="client-icon"><HandshakeIcon size={32} /></div>
              <h3>Technology Partners</h3>
              <p>Research institutions and technology firms collaborating on advanced hydrometallurgical processes.</p>
            </div>
            <div className="client-card">
              <div className="client-icon"><PillarIcon size={32} /></div>
              <h3>Government &amp; PSUs</h3>
              <p>Public sector units and policy bodies building India's critical mineral self-sufficiency.</p>
            </div>
          </div>

          <div className="section-cta reveal">
            <button className="btn-outline" onClick={() => navigate("/who-we-work-with")}>
              See Who We Serve →
            </button>
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section id="contact" className="contact-section">
        <div className="section-inner">
          <div className="contact-wrap">

            <div className="contact-info reveal">
              <div className="section-tag">Contact Us</div>
              <h2>
                Let's Build the<br />
                <span>Circular Economy</span><br />
                Together
              </h2>
              <p>
                Whether you're an OEM, recycler, or investor — we'd love to work with you.
              </p>
              <div className="contact-details">
                <div className="contact-detail">
                  <div className="cd-icon"><LocationIcon size={16} /></div>
                  <div className="cd-text">
                    <strong>Location</strong>
                    Jaipur, Rajasthan, India
                  </div>
                </div>
                <div className="contact-detail">
                  <div className="cd-icon"><MailIcon size={16} /></div>
                  <div className="cd-text">
                    <strong>Email</strong>
                    alankaarpower@gmail.com
                  </div>
                </div>
                <div className="contact-detail">
                  <div className="cd-icon"><PhoneIcon size={16} /></div>
                  <div className="cd-text">
                    <strong>Phone</strong>
                    +91 9799495123
                  </div>
                </div>
              </div>
            </div>

            <div className="form-box reveal">
              <form
                action="https://api.web3forms.com/submit"
                method="POST"
                onSubmit={handleSubmit}
              >
                <input type="hidden" name="access_key" value="a4972955-93fb-436e-ac21-4fb4f27485fb" />
                <input type="hidden" name="subject" value="New Enquiry - Alankaar Power" />
                <input type="hidden" name="from_name" value="Alankaar Website" />

                <div className="form-row">
                  <div className="form-group">
                    <label>Full Name *</label>
                    <input type="text" name="name" required />
                  </div>
                  <div className="form-group">
                    <label>Company *</label>
                    <input type="text" name="company" required />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Email *</label>
                    <input type="email" name="email" required />
                  </div>
                  <div className="form-group">
                    <label>Phone</label>
                    <input type="tel" name="phone" />
                  </div>
                </div>

                <div className="form-group">
                  <label>Enquiry Type *</label>
                  <select name="inquiry" required defaultValue="">
                    <option value="" disabled>Select your interest</option>
                    <option value="black_mass">Buy Black Mass</option>
                    <option value="oem_partnership">Buy From Us (Cu, Al, Fe, Plastic)</option>
                    <option value="bulk_disposal">Sell Battery Scrap (We Buy)</option>
                    <option value="epr_compliance">EPR Partnership</option>
                    <option value="investment">Investment</option>
                    <option value="technology">Technology</option>
                    <option value="general">General</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Message</label>
                  <textarea name="message"></textarea>
                </div>

                <button type="submit" className="form-submit">
                  Send Enquiry →
                </button>

                <p className="form-note">
                  We respond within 24 hours.
                </p>
              </form>
            </div>

          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer>
        <div className="footer-brand">
          <div className="logo">
            <div className="logo-name">ALANKAAR POWER</div>
            <div className="logo-sub">Corporation Private Limited</div>
          </div>
          <p style={{ marginTop: "1rem" }}>
            Closing the loop on lithium battery waste. Building India's critical mineral independence from the ground up.
          </p>
        </div>

        <div className="footer-col">
          <h4>Company</h4>
          <ul>
            <li><Link to="/what-we-do">What We Do</Link></li>
            <li><Link to="/process">Our Process</Link></li>
            <li><Link to="/market">Market</Link></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Get In Touch</h4>
          <ul>
            <li>Jaipur, Rajasthan</li>
            <li>alankaarpower@gmail.com</li>
            <li>+91 9799495123</li>
          </ul>
        </div>
      </footer>

      <div className="footer-bottom">
        <span>© 2025 Alankaar Power Corporation Pvt. Ltd. All rights reserved.</span>
        <span>CIN: U40100RJ2024PTC000000</span>
      </div>

      <div className="toast" id="toast">
        ✓ Enquiry sent! We'll be in touch within 24 hours.
      </div>
    </>
  );
}

// ─── ROOT APP WITH ROUTER ─────────────────────────────────────────────────────
function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/what-we-do" element={<WhatWeDoPage />} />
        <Route path="/why-it-matters" element={<WhyItMattersPage />} />
        <Route path="/process" element={<ProcessPage />} />
        <Route path="/why-us" element={<WhyUsPage />} />
        <Route path="/market" element={<MarketPage />} />
        <Route path="/who-we-work-with" element={<WhoWeWorkWithPage />} />
      </Routes>
    </>
  );
}

export default App;